import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const mergeAuthoringRecommendationNote = api(async function mergeAuthoringRecommendationNote({
    projectId,
    scheduleId,
    amendsKey,
    nextContent,
    nextContents,
    changeLabel,
    targetLabel,
}) {
    return mutate(
        gql`
            mutation MergeAuthoringRecommendationNote(
                $projectId: String!
                $scheduleId: String!
                $amendsKey: String!
                $nextContent: String
                $nextContents: [String!]
                $changeLabel: String
                $targetLabel: String
            ) {
                mergeAuthoringRecommendationNote(
                    projectId: $projectId
                    scheduleId: $scheduleId
                    amendsKey: $amendsKey
                    nextContent: $nextContent
                    nextContents: $nextContents
                    changeLabel: $changeLabel
                    targetLabel: $targetLabel
                )
            }
        `,
        {
            projectId,
            scheduleId,
            amendsKey,
            nextContent,
            nextContents,
            changeLabel,
            targetLabel,
        },
        { returns: "mergeAuthoringRecommendationNote" }
    )
})
